import React, { CSSProperties } from 'react';

interface IProps {
  style?: CSSProperties;

  [prop: string]: unknown;
}

export default ({ style, ...rest }: IProps) => {
  const defaultStyle = { width: 50, height: 50 };
  const styles = { ...defaultStyle, ...style };

  return (
    <svg xmlns="http://www.w3.org/2000/svg" style={styles} width={styles.width} height={styles.height}
         viewBox="0 0 50 50" fill="none" {...rest}>
      <path opacity="0.24"
            d="M25 35.1562C29.3147 35.1562 32.8125 31.6585 32.8125 27.3438C32.8125 23.029 29.3147 19.5312 25 19.5312C20.6853 19.5312 17.1875 23.029 17.1875 27.3438C17.1875 31.6585 20.6853 35.1562 25 35.1562Z"
            fill="#348AEB" />
      <path opacity="0.24"
            d="M11.7188 22.6562C15.1705 22.6562 17.9688 19.858 17.9688 16.4062C17.9688 12.9545 15.1705 10.1562 11.7188 10.1562C8.26697 10.1562 5.46875 12.9545 5.46875 16.4062C5.46875 19.858 8.26697 22.6562 11.7188 22.6562Z"
            fill="#348AEB" />
      <path opacity="0.24"
            d="M38.2812 22.6562C41.733 22.6562 44.5312 19.858 44.5312 16.4062C44.5312 12.9545 41.733 10.1562 38.2812 10.1562C34.8295 10.1562 32.0312 12.9545 32.0312 16.4062C32.0312 19.858 34.8295 22.6562 38.2812 22.6562Z"
            fill="#348AEB" />
      <path
        d="M25 35.1562C29.3147 35.1562 32.8125 31.6585 32.8125 27.3438C32.8125 23.029 29.3147 19.5312 25 19.5312C20.6853 19.5312 17.1875 23.029 17.1875 27.3438C17.1875 31.6585 20.6853 35.1562 25 35.1562Z"
        stroke="#348AEB" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
      <path
        d="M38.2812 22.6563C40.1011 22.6532 41.8964 23.0755 43.5241 23.8893C45.1518 24.7032 46.5668 25.8861 47.6562 27.3438"
        stroke="#348AEB" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
      <path
        d="M2.34375 27.3438C3.4332 25.8861 4.8482 24.7032 6.4759 23.8893C8.10359 23.0755 9.89894 22.6532 11.7188 22.6563"
        stroke="#348AEB" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
      <path
        d="M13.7497 42.1879C14.7786 40.0806 16.3788 38.3047 18.3678 37.0625C20.3567 35.8203 22.6546 35.1616 24.9997 35.1616C27.3447 35.1616 29.6426 35.8203 31.6316 37.0625C33.6206 38.3047 35.2207 40.0806 36.2497 42.1879"
        stroke="#348AEB" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
      <path
        d="M11.719 22.6562C10.5327 22.6575 9.37065 22.321 8.3685 21.6863C7.36634 21.0516 6.56552 20.1448 6.05959 19.0718C5.55366 17.9989 5.36353 16.8041 5.5114 15.6271C5.65928 14.4501 6.13906 13.3395 6.89468 12.4251C7.6503 11.5106 8.65056 10.8301 9.77858 10.463C10.9066 10.0959 12.1158 10.0575 13.2649 10.3521C14.414 10.6467 15.4555 11.2622 16.2677 12.1268C17.08 12.9913 17.6294 14.0692 17.8518 15.2344"
        stroke="#348AEB" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
      <path
        d="M32.1487 15.2344C32.3712 14.0692 32.9206 12.9913 33.7328 12.1268C34.5451 11.2622 35.5866 10.6467 36.7357 10.3521C37.8847 10.0575 39.0939 10.0959 40.222 10.463C41.35 10.8301 42.3502 11.5106 43.1059 12.4251C43.8615 13.3395 44.3413 14.4501 44.4891 15.6271C44.637 16.8041 44.4469 17.9989 43.941 19.0718C43.435 20.1448 42.6342 21.0516 41.632 21.6863C40.6299 22.321 39.4678 22.6575 38.2816 22.6562"
        stroke="#348AEB" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  );
};
